// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__huf5h","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__36jQO"};